export default "__VITE_ASSET__CglbxldH__"